exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n#xsFooter {\n  color: #e5e7ea;\n  text-align: center;\n  margin-bottom: 40px;\n  font-size: 12px;\n}\n", ""]);

// exports
